import { Box, Link, Text, VStack } from 'native-base';
import React, { ReactNode } from 'react';

import HTML from 'app/components/HTML';
import {
  AttractionLocation as TAttractionLocation,
  Location,
  Text as TText,
} from 'app/generated/hygraph';
import { toLabelURL, toURL } from 'app/utils/url';

export type AttractionLocationProps = {
  children?: ReactNode;
  location: Pick<
    TAttractionLocation,
    'name' | 'address' | 'addressNote' | 'hours' | 'phone' | 'website' | 'website'
  > & {
    hoursNotes: Pick<TText, 'value'>[];
    geolocation: Maybe<Pick<Location, 'latitude' | 'longitude'>>;
  };
};

export default function AttractionLocation({ location }: AttractionLocationProps) {
  return (
    <Box testID="AttractionLocation">
      <VStack space="3">
        <Box>
          <Text selectable>
            {[(location.name || '').toUpperCase(), ...(location.address || [])].map((value) => (
              <Text key={value}>
                {value}
                {`\n`}
              </Text>
            ))}
          </Text>
        </Box>

        {!!location.addressNote && (
          <HTML
            defaultTextProps={{
              selectable: true,
            }}
            html={location.addressNote}
          />
        )}

        <Box>
          {location.phone?.map((value) => (
            <HTML
              key={value}
              defaultTextProps={{
                selectable: true,
              }}
              html={value}
            />
          ))}
          {!!location.website && (
            <Link href={toURL(location.website)} isExternal>
              <Text bold selectable underline>
                {toLabelURL(location.website)}
              </Text>
            </Link>
          )}
        </Box>

        <Box>
          {location.hours?.map((value) => (
            <HTML
              key={value}
              defaultTextProps={{
                selectable: true,
              }}
              html={value}
            />
          ))}
        </Box>

        <Box>
          {location.hoursNotes?.map(({ value }) => (
            <HTML
              key={value}
              defaultTextProps={{
                selectable: true,
              }}
              html={value}
            />
          ))}
        </Box>
      </VStack>
    </Box>
  );
}
